export const useNumConverter = () => {
  /**
   * 日本円をカンマ区切りの文字列に変換する
   * @params {number?} yen
   * NOTE: yenがnullまたはundefinedの場合はtoLocaleStringがエラーになるので'0'を返す
   */
  const separateByComma = (yen?: number) => {
    if (yen == null) return '0';
    return yen.toLocaleString();
  };

  /**
   * 指定した小数点桁数で切り捨てる
   * @params {number} value
   * @params {number} digits 小数点桁数
   * @example roundDown(123.456, 2) => 123.45, roundDown(123.456, -1) => 120
   */
  const roundDown = (value: number, digits: number) => {
    if (value < 0) {
      console.error('0以上で指定する必要があります');
      return value;
    }
    return Math.floor(value * Math.pow(10, digits)) / Math.pow(10, digits);
  };

  return {
    separateByComma,
    roundDown,
  };
};
